// Vendored from @openpanel/web@1.4.1/dist/replay-V6FXES7X.js.
//
// The upstream SDK loads this module via `import("./replay-V6FXES7X.js")`
// — a runtime dynamic import targeting a file that is not exposed via
// `package.json#exports`, so CRA/webpack cannot bundle it as a chunk.
// We copy it into src/ so webpack picks it up at build time, and the
// initAnalytics wrapper monkey-patches `OpenPanel.loadReplayModule` to
// return this module directly instead of attempting the broken dynamic
// import. Self-hosted deployments also have the issue that
// `/op1-replay.js` is intercepted by the dashboard auth middleware, so
// vendoring is the only path to working session replay on self-host.
//
// Keep this file byte-for-byte identical to the upstream output other
// than formatting — re-vendor whenever @openpanel/web is upgraded.

/* eslint-disable */
import { record as C } from 'rrweb';

var s = null;

function I(o, f) {
  if (typeof document > 'u' || typeof window > 'u') return;
  s && s();
  let v = o.maxEventsPerChunk ?? 200,
    i = o.flushIntervalMs ?? 1e4,
    k = o.maxPayloadBytes ?? 1048576,
    e = [],
    d = 0,
    r = null;
  function l(t) {
    if (e.length === 0) return;
    let n = JSON.stringify(e);
    if (new TextEncoder().encode(n).length > k) {
      if (e.length > 1) {
        let a = Math.floor(e.length / 2),
          y = e.slice(0, a),
          R = e.slice(a),
          _ = t && y.some((T) => T.type === 2);
        e = y;
        l(_);
        e = R;
        l(!1);
        return;
      }
      e = [];
      return;
    }
    let x = e[0].timestamp,
      S = e[e.length - 1].timestamp;
    try {
      f({
        chunk_index: d,
        events_count: e.length,
        is_full_snapshot: t,
        started_at: new Date(x).toISOString(),
        ended_at: new Date(S).toISOString(),
        payload: n,
      });
      d += 1;
      e = [];
    } catch (a) {
      console.error('[ReplayRecorder] sendChunk failed', a);
      throw a;
    }
  }
  function g(t) {
    let n = t || e.some((m) => m.type === 2);
    if (e.length >= v) l(n);
    else if (t && e.length > 0) l(!0);
  }
  let c = o.maskAllText !== !1,
    u = o.unmaskTextSelector;
  let b = C({
    emit(t, n) {
      e.push(t);
      g(!!n);
    },
    checkoutEveryNms: i,
    maskAllInputs: o.maskAllInputs ?? !0,
    maskTextSelector: c ? '*' : '[data-openpanel-replay-mask]',
    maskTextFn: c && u ? (t, n) => (n?.closest(u) ? t : t.replace(/\S/g, '*')) : void 0,
    blockSelector: o.blockSelector ?? '[data-openpanel-replay-block]',
    blockClass: o.blockClass,
    ignoreSelector: o.ignoreSelector,
  });
  r = setInterval(() => {
    if (e.length > 0) {
      let t = e.some((n) => n.type === 2);
      l(t);
    }
  }, i);
  function p() {
    if (document.visibilityState === 'hidden' && e.length > 0) {
      let t = e.some((n) => n.type === 2);
      l(t);
    }
  }
  function h() {
    if (e.length > 0) {
      let t = e.some((n) => n.type === 2);
      l(t);
    }
  }
  document.addEventListener('visibilitychange', p);
  window.addEventListener('pagehide', h);
  s = () => {
    if (e.length > 0) {
      let t = e.some((n) => n.type === 2);
      l(t);
    }
    if (r) {
      clearInterval(r);
      r = null;
    }
    document.removeEventListener('visibilitychange', p);
    window.removeEventListener('pagehide', h);
    b?.();
    s = null;
  };
}

function w() {
  s && s();
}

export { I as startReplayRecorder, w as stopReplayRecorder };
